import React from 'react';
import { Form } from '../../../ui/universe';
import { Tooltip } from 'tdesign-react';

/**
 * 分组小标题渲染器
 * 仅用于参数分组展示，不参与接口请求（配置 excludeFromRequest）
 */
function SectionRenderer({ params }) {
  return (
    <Form.Item className="column" label={undefined}>
      <div
        style={{
          width: '100%',
          borderTop: '1px solid #EAEDF2',
          paddingTop: '16px',
          marginBottom: '12px',
        }}
      >
        <span style={{ fontSize: '15px', fontWeight: 600, color: '#010B32' }}>
          {params.sectionTitle || params.label}
        </span>
        {params.sectionTip && (
          <span style={{ marginLeft: '8px', fontSize: '13px', color: '#00000073' }}>
            {params.sectionTip}
          </span>
        )}
        {params.des && (
          <Tooltip content={params.des} theme="light">
            <span className="ocrDemo-icon-question" style={{ marginLeft: '6px' }}></span>
          </Tooltip>
        )}
      </div>
    </Form.Item>
  );
}

export default SectionRenderer;
